import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {ColumnMap, ColumnSetting} from './layout.model';

@Component({
  selector: 'base-table-layout',
  templateUrl: './table-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableLayoutComponent implements OnChanges {
  //data
  @Input() records: any[];
  @Input() footer: any;

  //settings
  @Input() settings: ColumnSetting[];
  columnMaps: ColumnMap[];

  //grid params
  @Input() showHeader: boolean = true;
  @Input() gridActions: any;
  @Input() hasRowCheckbox: any;
  @Input() searched: boolean;
  @Input() loading: boolean;
  @Input() downloading: boolean;
  @Input() checkboxLoading: boolean;
  @Input() count: number;

  //paging
  @Input() showPagination: boolean = true;
  @Input() pageSize: any;
  @Input() pageNum: any;
  @Input() pageMax: any;

  //sorting
  @Input() showSort: boolean = true;
  @Input() sortNum: any;
  @Input() sortDir: any;

  //visuals
  @Input() visuals: any;
  @Input() genericVisuals: any;

  @Output()
  outputMethodHandler: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  changePageHandler: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  changePageSizeHandler: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  changeSortHandler: EventEmitter<any> = new EventEmitter<any>();

  ngOnChanges() {
    if (this.settings) {
      this.columnMaps = this.settings.map((col) => new ColumnMap(col));
      if (this.records && this.columnMaps[0]) {
        this.records.forEach((record) => {
          let realActionNumber = 0;

          if (this.hasRowCheckbox) {
            record.hasRowCheckbox = !this.renderBoolean(this.hasRowCheckbox, record);
          }
          record.columnMaps = this.copy(this.columnMaps); //Object.assign([], this.columnMaps);
          if (record.columnMaps[0].actions) {
            record.columnMaps[0].actions.forEach((action) => {
              action.isHidden = this.renderBoolean(action.hidden, record);
              if (!action.isHidden) {
                realActionNumber++;
              }
              action.isDisabled = this.renderBoolean(action.disabled, record);
            });
          }
          record.actionViewType = realActionNumber;
        });
      }
    } else {
      this.columnMaps = Object.keys(this.records[0]).map((key) => {
        return new ColumnMap({columnKey: key});
      });
    }
  }

  parentMethodHandle(method: any, params = {}) {
    if (typeof method === 'string') {
      params['methodName'] = method;
    }

    this.outputMethodHandler.emit(params);
  }

  renderBoolean(str: string, params = {}): boolean {
    let ret = eval(str);
    return ret;
  }

  strToBoolean(str: string): boolean {
    if (str != null && str != '' && (str.toUpperCase() == 'Y' || str.toUpperCase() == 'YES')) {
      return true;
    } else {
      return false;
    }
  }

  getSortState(column) {
    return this.sortNum == column ? (this.sortDir == 'asc' ? 'sortasc' : 'sortdesc') : 'unsorted';
  }

  changePage(num: number, type: string): void {
    this.changePageHandler.emit({num: num, type: type});
  }

  changePageSize(num: number): void {
    this.changePageSizeHandler.emit(num);
  }

  changeSort(num: string): void {
    this.changeSortHandler.emit(num);
  }

  copy(o) {
    var output, v, key;
    output = Array.isArray(o) ? [] : {};
    for (key in o) {
      v = o[key];
      output[key] = typeof v === 'object' && v !== null ? this.copy(v) : v;
    }
    return output;
  }
}
